export default __webpack_public_path__ + "static/top-5869c9e01e6e9f6ca8ae3c0e262953a7.png";